import {effect, Injectable, signal} from '@angular/core';
import {IFormState} from '../models/i-form-state';
import {FormGroup} from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class FormStateService {
  forms = signal<IFormState[]>([]);

  private resettingSections = new Set<string>();

  constructor() {
    this.getForms();

    effect(() => {
      const currentData = this.forms();
      sessionStorage.setItem('forms', JSON.stringify(currentData));
    });
  }

  getForms(): void {
    const formsJson: string | null = sessionStorage.getItem('forms');

    if (!formsJson) {
      return this.forms.set([]);
    }

    const forms = JSON.parse(formsJson);
    this.forms.set(forms);
  }

  getForm(section: string): IFormState | null {
    const form: IFormState | undefined = this.forms().find(f => f.section == section);
    return form ?? null;
  }

  updateForm(formData: any, section: string, id: number | null = null): void {
    const form: IFormState = {
      section: section,
      id: id,
      data: formData,
      firstClickAttempted: false
    }

    this.forms.update((data: IFormState[]) => {
      const exists: boolean = data.some(f => f.section == section);

      if (exists) {
        return data.map(f => f.section == section ? form : f);
      }

      return [...data, form];
    })
  }

  setFirstClickAttempted(section: string): void {
    this.forms.update((data: IFormState[]) => {
      return data.map(f => ({
        ...f,
        firstClickAttempted: f.section === section
      }));
    })
  }

  setResetting(section: string, value: boolean) {
    if (value) this.resettingSections.add(section);
    else this.resettingSections.delete(section);
  }

  isResetting(section: string): boolean {
    return this.resettingSections.has(section);
  }

  clearForm(section: string): void {
    this.forms.update(data => data.filter(f => f.section != section));
  }

  // Aggiungi questo metodo nel tuo FormStateService
  scrollToField(form: FormGroup, controlName?: string): void {
    form.markAllAsTouched();
    form.markAsDirty();

    // Selettore: cerca per nome specifico o per classi di errore
    const selector = controlName
      ? `[formControlName="${controlName}"], [name="${controlName}"], .${controlName}`
      : '.ng-invalid.ng-touched:not(form), .ng-invalid.ng-dirty:not(form), .p-invalid, .file-placeholder-error';

    setTimeout(() => {
      const element = document.querySelector(selector) as HTMLElement;
      const scrollContainer = document.getElementById('main-content');

      if (element && scrollContainer) {
        // 1. Calcoliamo la posizione dell'elemento rispetto al viewport
        const elementRect = element.getBoundingClientRect();
        const containerRect = scrollContainer.getBoundingClientRect();

        // 2. Calcoliamo l'offset
        // 24px di margine superiore per non appiccicarlo all'header
        const offset = 150;

        // Calcolo: posizione attuale scroll + distanza relativa dell'elemento - offset
        const scrollToPosition = scrollContainer.scrollTop + (elementRect.top - containerRect.top) - offset;

        // 3. Eseguiamo lo scroll fluido solo sul contenitore
        scrollContainer.scrollTo({
          top: scrollToPosition,
          behavior: 'smooth'
        });

        // 4. Focus sull'input per comodità dell'utente
        // const input = element.querySelector('input, textarea, .p-inputtext') as HTMLElement;
        // if (input) input.focus();
      }
    }, 50);
  }
}
